import * as React from 'react';
import * as classnames from 'classnames';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import { UilDraggabledots } from '@iconscout/react-unicons';

interface BubbleDragContainerProps {
    children: JSX.Element;
    index: number;
    disableAddBubble?: boolean;
    disableState?: boolean; //disabled is reserved on react-sortable-hoc
}

const BubbleDragContainer: React.FC<BubbleDragContainerProps> = ({
    children,
    disableAddBubble,
    disableState
}: BubbleDragContainerProps) => {
    const [showHandle, setShowHandle] = React.useState(false);
    return (
        <div
            className="bubble--drag--container"
            onMouseEnter={() => setShowHandle(true)}
            onMouseLeave={() => setShowHandle(false)}
        >
            <div
                className={classnames('bubble--drag--container--handle', {
                    disabled: disableAddBubble || disableState
                })}
                onMouseOver={() => setShowHandle(true)}
            >
                <DragHandle />
            </div>
            <div className="bubble--drag--container--contents">{children}</div>
        </div>
    );
};
const DragHandle = SortableHandle(() => <UilDraggabledots size={20} />);

export default SortableElement(BubbleDragContainer);
